import { BasecampRole } from "@utils/types";

// Mirrors basecamp.views.qa_rule_views.ALLOWED_ROLES — who can see and change QA rules.
export const QA_RULES_ROLES: BasecampRole[] = [BasecampRole.ADMIN, BasecampRole.ENTERPRISE_ADMIN];

// Mirrors api.models.qa_rule.RuleSet.PackageType
export const PackageType = {
  BASE: "base",
  INSURANCE: "insurance",
  CUSTOM: "custom",
} as const;
export type PackageType = (typeof PackageType)[keyof typeof PackageType];

// Mirrors api.services.qa_rule_resolver.PackageSource — why a package applies to a report.
export const PackageSource = {
  BASE: "base",
  INSURANCE: "insurance",
  ORGANIZATION: "organization",
  TEMPLATE: "template",
} as const;
export type PackageSource = (typeof PackageSource)[keyof typeof PackageSource];

// Mirrors api.services.qa_rule_resolver.TurnedOffBy
export const TurnedOffBy = {
  ORGANIZATION_PACKAGE: "organization_package",
  TEMPLATE_PACKAGE: "template_package",
  ORGANIZATION_RULE: "organization_rule",
  TEMPLATE_RULE: "template_rule",
} as const;
export type TurnedOffBy = (typeof TurnedOffBy)[keyof typeof TurnedOffBy];

export const QARulesParam = {
  RULE: "rule",
} as const;

export const QA_RULES_PATH = "/qa-rules";

// `?tab=` value of the QA Rules tab on the org and template detail pages.
export const DETAIL_PAGE_QA_TAB = "qa-rules";

// Client-side key for the preview query (the preview endpoint is a POST, so Orval
// generates no query key for it).
export const QA_RULE_PREVIEW_QUERY_KEY = "qa-rule-preview";

// Package report category. ALL (empty report_types) is what imported packages get;
// ABA = Initial Assessment + Reassessment; DIAGNOSIS = Diagnosis Evaluation.
export const ReportCategory = {
  ALL: "all",
  ABA: "aba",
  DIAGNOSIS: "diagnosis",
} as const;
export type ReportCategory = (typeof ReportCategory)[keyof typeof ReportCategory];

// Which detail page is editing QA: its toggles write rows at this level only.
export const QARulesScope = {
  TEMPLATE: "template",
  ORGANIZATION: "organization",
} as const;
export type QARulesScope = (typeof QARulesScope)[keyof typeof QARulesScope];

// Package-type filter value on the packages tab meaning "every type".
export const PACKAGE_TYPE_FILTER_ALL = "all";
